import { newAPI } from 'services';

export const requestBusinessUuid = async userId => {
  const response = await newAPI.get(`${userId}/business/view`);
  return response.data;
}

export const requestListTokens = async (userId, businessUuid) => {
  const response = await newAPI.get(`${userId}/business/${businessUuid}/integrations`);
  return response.data;
}